import { createAsyncThunk } from '@reduxjs/toolkit';

import { GeofenceRotationsService } from '../../services';

export const createRotation = createAsyncThunk(
  'geofence-rotations/createRotation',
  async (data, { rejectWithValue }) => {
    try {
      const response = await GeofenceRotationsService.createRotation(data);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create rotations');
    }
  }
);

export const fetchRotations = createAsyncThunk(
  'geofence-rotations/fetchRotations',
  async (params, { rejectWithValue }) => {
    try {
      const response = await GeofenceRotationsService.fetchRotations(params);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch rotations');
    }
  }
);

export const updateRotation = createAsyncThunk(
  'geofence-rotations/updateRotation',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await GeofenceRotationsService.updateRotation({ id, data });

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update rotation');
    }
  }
);

export const deleteRotation = createAsyncThunk('geofence-rotations/deleteRotation', async (id, { rejectWithValue }) => {
  try {
    const response = await GeofenceRotationsService.deleteRotation(id);

    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to delete rotation');
  }
});
